




















import { TagModel } from '@/type/api';
import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<FeedContentTags>({})
export default class FeedContentTags extends Vue {
  // PROPS
  @Prop({ type: Array, default: () => [] })

  // FIELDS
  tags!: TagModel.Read.Response.List[];
}
